export enum ColorCodeEnum {
  BLUE = 0,
  GREEN = 1,
  YELLOW = 2
}